import { CALL_API } from 'redux-api-middleware';
import { keyBy } from 'lodash';
import { commonHeaders } from 'helpers/api';
import { createReducer } from 'helpers/redux';
import { getConfig } from 'modules/config';

export const namespace = 'libraries';

export const LIST = 'vtn/libraries/LIST_LIBRARIES';
export const LIST_SUCCESS = 'vtn/libraries/LIST_LIBRARIES_SUCCESS';
export const LIST_FAILURE = 'vtn/libraries/LIST_LIBRARIES_FAILURE';

export const LIST_TYPES = 'vtn/libraries/LIST_LIBRARY_TYPES';
export const LIST_TYPES_SUCCESS = 'vtn/libraries/LIST_LIBRARY_TYPES_SUCCESS';
export const LIST_TYPES_FAILURE = 'vtn/libraries/LIST_LIBRARY_TYPES_FAILURE';

const defaultState = {
  librariesById: {},
  loadingLibraries: false,
  failedLoadingLibraries: false,
  libraryTypesById: {},
  loadingLibraryTypes: false,
  failedLoadingLibraryTypes: false
};

const reducer = createReducer(defaultState, {
  [LIST](state, action) {
    return {
      ...state,
      loadingLibraries: true
    };
  },
  [LIST_SUCCESS](state, action) {
    return {
      ...state,
      loadingLibraries: false,
      librariesById: {
        ...state.librariesById,
        ...keyBy(action.payload.results, 'libraryId')
      }
    };
  },
  [LIST_FAILURE](state, action) {
    return {
      ...state,
      loadingLibraries: false,
      failedLoadingLibraries: true
    };
  },
  [LIST_TYPES](state, action) {
    return {
      ...state,
      loadingLibraryTypes: true
    };
  },
  [LIST_TYPES_SUCCESS](state, action) {
    return {
      ...state,
      loadingLibraryTypes: false,
      libraryTypesById: {
        ...state.libraryTypesById,
        ...keyBy(action.payload.results, 'libraryTypeId')
      }
    };
  },
  [LIST_TYPES_FAILURE](state, action) {
    return {
      ...state,
      loadingLibraryTypes: false,
      failedLoadingLibraries: true
    };
  }
});

export default reducer;

function local(state) {
  return state[namespace];
}

export function listLibraries(libraryTypes = []) {
  return {
    [CALL_API]: {
      types: [LIST, LIST_SUCCESS, LIST_FAILURE].map(type => ({
        type,
        meta: { libraryTypes }
      })),
      endpoint: state =>
        `${getConfig(state)
          .restApiRoot}/media/library?libraryType=${libraryTypes.join(',')}`,
      method: 'GET',
      headers: commonHeaders
    }
  };
}

export function listLibraryTypes(libraryIdentityTypes = []) {
  return {
    [CALL_API]: {
      types: [LIST_TYPES, LIST_TYPES_SUCCESS, LIST_TYPES_FAILURE].map(type => ({
        type,
        meta: { libraryIdentityTypes }
      })),
      endpoint: state =>
        `${getConfig(state)
          .restApiRoot}/media/library-type?identifierType=${libraryIdentityTypes.join(
          ','
        )}`,
      method: 'GET',
      headers: commonHeaders
    }
  };
}

export function getLibraries(state) {
  return local(state).librariesById;
}

export function getLoadingLibraries(state) {
  return local(state).loadingLibraries;
}

export function getFailedLoadingLibraries(state) {
  return local(state).failedLoadingLibraries;
}



// WEBPACK FOOTER //
// ./src/client/modules/library/index.js